import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filter"
})
export class FilterPipe implements PipeTransform {
  transform(value: any, fieldValue: any, fieldName: string): any {
    if (!value) { return []; }
    if (!fieldName || !fieldValue) { return value; }
    return value.filter((d: any) => d[fieldName] === fieldValue);
  }
}
